/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useState, useEffect} from "react";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";


import FormFieldsGroupHeaderComponent from "@Components/UI/Forms/Group/Header";
import FormFieldsGroupFieldsComponent from "@Components/UI/Forms/Group/Fields";
import FormFieldsGroupComponent from "@Components/UI/Forms/Group";
import FormFieldComponent from "@Components/UI/Forms/Field";
import DefaultFormButton from "@Components/UI/Forms/Buttons/Default";


import {PasswordResetFormStepType, PasswordResetErrorsInterface} from "@UIPages/NotAuthenticated/PasswordReset";
import {Col} from "react-bootstrap";
import DefaultMessageComponent from "@Components/UI/Communicates/Messages/Default";

type PasswordResetFormStep2Props = {
    forwardRef?: React.ForwardedRef<any> | null;
    passwordResetFormStep: PasswordResetFormStepType; passwordResetFormStepHandler(step: number, final?: boolean): void;
    passwordResetFormErrors: PasswordResetErrorsInterface;
    formUserSmsCode: string; formUserSmsCodeHandler(e: React.ChangeEvent<HTMLInputElement> | string): void; formUserSmsCodeValidDate: string;
};

export const PasswordResetFormStep2Component: React.FC<PasswordResetFormStep2Props> = ({
    forwardRef = null,
    passwordResetFormStep, passwordResetFormStepHandler, passwordResetFormErrors,
    formUserSmsCode, formUserSmsCodeHandler, formUserSmsCodeValidDate
}): JSX.Element | null => {


    const REST_API_REQUEST_STATUS= useTypedSelector(
        (state):ReturnType<any> => state.interface
    )?.apiRequestStatus;


    const [formUserSmsCodeValidTime, setFormUserSmsCodeValidTime] = useState<number>(0);
    const [activeCountDownTimeOut, setActiveCountDownTimeOut] = useState<any>(null);

    useEffect(() => {
        const smsCodeValidDateTime = new Date(formUserSmsCodeValidDate);
        const smsCodeValidLeftTime = smsCodeValidDateTime.getTime() - (new Date()).getTime();
        if (!smsCodeValidLeftTime || smsCodeValidLeftTime < 0) return;
        if (activeCountDownTimeOut) window.clearTimeout(activeCountDownTimeOut);
        formUserSmsCodeHandler("");
        setFormUserSmsCodeValidTime(Math.floor(smsCodeValidLeftTime / 1000));
        return () => setFormUserSmsCodeValidTime(0);
    }, [formUserSmsCodeValidDate]);

    useEffect(() => {
        if (formUserSmsCodeValidTime > 0) {
            const timeout = setTimeout(() => setFormUserSmsCodeValidTime(formUserSmsCodeValidTime - 1), 1000);;
            setActiveCountDownTimeOut(timeout);
        } else {
            window.clearTimeout(activeCountDownTimeOut);
        }
    }, [formUserSmsCodeValidTime]);


    const leftMinutes = Math.floor(formUserSmsCodeValidTime / 60) || 0
    const leftSeconds = formUserSmsCodeValidTime % 60 || 0;

    const formattedTime = `${(leftMinutes < 10 ? "0" : "" ) + leftMinutes.toString()}:${(leftSeconds < 10 ? "0" : "" ) + leftSeconds.toString()}`;


    return (
        <FormFieldsGroupComponent forwardRef={forwardRef} cssClasses={passwordResetFormStep !== 2 ? "disabled" : ""}>

            <FormFieldsGroupFieldsComponent>

                <FormFieldComponent
                    lg={{span: 4, offset: 4}}
                    fieldValue={formUserSmsCode}
                    fieldValueHandler={e => formUserSmsCodeHandler(e)}
                    fieldType={"number"} fieldLabel={`Podaj kod weryfikacyjny`} fieldControlID={`password-reset-form-user-sms-code`}
                    fieldDisabledStatus={passwordResetFormStep !== 2 || !!REST_API_REQUEST_STATUS}
                    fieldError={passwordResetFormErrors?.formUserSmsCode}
                    fieldLegend={`Pozostały czas: ${formattedTime}`}
                />

            </FormFieldsGroupFieldsComponent>


            <Col xs={12} style={{padding: 0, marginBottom: 20}}>
                <DefaultMessageComponent messageText={"Na numer telefonu zarejestrowany w CDOK zostanie wysłany kod weryfikacyjny"} />
            </Col>

            <>
            {passwordResetFormStep === 2 &&
            <DefaultFormButton
                buttonText={`Dalej`}
                clickHandler={() => passwordResetFormStepHandler(3)}
                controlId={`password-reset-form-step2-submit`}
                disabled={!!REST_API_REQUEST_STATUS}
                cssClasses={`password-reset-form-step-submit`}
            />
            }
            </>

        </FormFieldsGroupComponent>
    );

};


export default PasswordResetFormStep2Component;
